import React from 'react';
import { Box, Section, Image } from '@common/components';
import { Button, Row, Col, Typography } from 'antd';
import { DeleteFilled, EditFilled } from '@ant-design/icons';

const Service = ({ service, onClick, onEdit, onDelete }) => {
	return (
		<Box className="p-5" onClick={() => onClick && onClick(service)}>
			<Section className="mb-3" hoverable shadowed>
				<Image src={service?.thumbnail?.path} width="100%" mb={20} />
				<Row type="flex" className="login-links">
					<Col>
						<Typography.Title level={4}>
							{service.title}
						</Typography.Title>
					</Col>
				</Row>
				<Box textAlign="right">
					{onEdit && (
						<Button
							size="small"
							type="text"
							onClick={() => onEdit && onEdit(service)}>
							<EditFilled style={{ color: '#FFCC00' }} />
						</Button>
					)}
					{onDelete && (
						<Button
							size="small"
							type="text"
							onClick={() => onDelete && onDelete(service)}>
							<DeleteFilled style={{ color: '#FF0000' }} />
						</Button>
					)}
				</Box>
			</Section>
		</Box>
	);
};

export default Service;
